import React, { Component } from 'react';
import './MyNFTs.css';
import * as encryptUtils from './encryptDecryptUtils';
import * as loggingUtils from './utils/loggingUtils';
import * as scriptUtils from './utils/scriptUtils';
import PlatformSidebar from './PlatformSidebar';
import Onboarding from './Onboarding.js';
import AddFunds from './AddFunds.js';
import ImportFromPassword from './ImportFromPassword';
import PurchasedNFT from './PurchasedNFT';
import TransactionStatus from './TransactionStatus';
import { contractAddress, mainnetContractAddress, bondingCurveContractAddress, mainnetBondingCurveContractAddress } from "./config";
import { createAlchemyWeb3 } from "@alch/alchemy-web3";
import ShowMoreText from "react-show-more-text";
const contract = require("./artifacts/contracts/The402NFT.sol/The402NFT.json");
const contract2 = require("./artifacts/contracts/BondingCurveNFT.sol/BondingCurveNFT.json");

let web3;
let usedContractAddress;
let usedContractAddressBondingCurve;
if(process.env.REACT_APP_IS_MAINNET !== "testnet") {
  web3 = createAlchemyWeb3(process.env.REACT_APP_ETHEREUM_WEBSOCKET_URL);
  usedContractAddress = mainnetContractAddress;
  usedContractAddressBondingCurve = mainnetBondingCurveContractAddress;
} else {
  web3 = createAlchemyWeb3(process.env.REACT_APP_GOERLI_WEBSOCKET_URL);
  usedContractAddress = contractAddress;
  usedContractAddressBondingCurve = bondingCurveContractAddress;
}

const axios = require('axios');

class MarketplaceSecondaries extends Component {
  constructor(props) {
    super(props);
    this.selectModal = this.selectModal.bind(this);
    this.onUserClickedConnectWallet = this.onUserClickedConnectWallet.bind(this);
    this.delistItem = this.delistItem.bind(this);
    this.purchaseItem = this.purchaseItem.bind(this);
    this.redirectToItem = this.redirectToItem.bind(this);

    this.state = {
      item: null,
      isLoading: true,
      modalShown: '',
      marketItems: [],
      ethToWeiConversion: 1000000000000000000,
      listingPrice: 0,
      USDPrice: "Invalid coinbase exchange rate request",
      transactionStatus: "None"
    }
  }

  onUserClickedConnectWallet(marketItem) {
    loggingUtils.logEvent(
      encryptUtils.getWalletUnconnectedUserId(),
      'marketplace_secondaries',
      'marketplace_secondaries_click_buy_with_wallet_disconnected',
      'info',
      "https://the402.xyz",
      {
        item: marketItem,
      },
    );
    let buttons = document.getElementsByTagName("button");
    for(let i = 0; i < buttons.length; i++) {
      let button = buttons[i];
      if(button.outerText === "Connect Wallet") {
        button.click();
      }
    }
  }

  async delistItem(marketItem) {
    this.setState({
      transactionStatus: "Pending",
    });
    let didApprove = await encryptUtils.delistNFT(this.props.account.address, marketItem.marketItemId, marketItem.protocol);
    if(didApprove) {
      loggingUtils.logEvent(
        this.props.account.address,
        'marketplace_secondaries',
        'marketplace_secondaries_delist_item',
        'info',
        "https://the402.xyz",
        {},
      );
    } else {
      this.setState({
        transactionStatus: "None",
      });
    }
  }

  async purchaseItem(marketItem) {
    if(this.props.account == null) {
      loggingUtils.logEvent(
        encryptUtils.getWalletUnconnectedUserId(),
        'marketplace_secondaries',
        'marketplace_secondaries_click_purchase_with_wallet_disconnected',
        'info',
        "https://the402.xyz",
        {
          marketItem: marketItem
        },
      );
      this.onUserClickedConnectWallet(marketItem);
    } else {
      this.setState({
        transactionStatus: "Pending",
      });
      let didApprove = await encryptUtils.purchaseNFT(this.props.account.address, marketItem.marketItemId, marketItem.protocol, marketItem.price);
      if(didApprove) {
        loggingUtils.logEvent(
          this.props.account.address,
          'marketplace_secondaries',
          'marketplace_secondaries_purchase_item',
          'info',
          "https://the402.xyz",
          {
            marketItem: marketItem
          },
        );
      } else {
        this.setState({
          transactionStatus: "None",
        });
      }
    }
  }

  redirectToItem() {
    let urlSplit = window.location.href.split("/");
    let itemInfoSplit = urlSplit[urlSplit.length - 1].split("?protocol=");
    let authUUID = decodeURIComponent(itemInfoSplit[0]);
    let protocol = itemInfoSplit[1];
    window.location.href = window.location.origin + "/media/" + authUUID + "?protocol=" + protocol;
  }

  selectModal(modal) {
    this.setState({
      modalShown: modal,
    });
  }

  async componentDidMount() {
    let urlSplit = window.location.href.split("/");
    let itemInfoSplit = urlSplit[urlSplit.length - 1].split("?protocol=");
    let authUUID = decodeURIComponent(itemInfoSplit[0]);
    let protocol = itemInfoSplit[1];
    let item = await encryptUtils.getNFTDetails(authUUID, protocol);
    let marketItems = await encryptUtils.getMarketItems();
    marketItems = marketItems.filter(
      marketItem => marketItem.authUUID === item["authUUID"] && marketItem.protocol === protocol
    );
    for(let i = 0; i < marketItems.length; i++) {
      let marketItem = marketItems[i];
      let rawAddress = marketItem["sellerAddress"];
      if(rawAddress != null) {
        rawAddress = rawAddress.substring(0, 5) + "..." + rawAddress.substring(rawAddress.length - 5);
      }
      marketItem["displayedSellerAddress"] = rawAddress;
      marketItem["sellerProfileImage"] = scriptUtils.getProfileImage(marketItem["sellerAddress"]);
      marketItems[i] = marketItem;
    }
    this.setState({
      item,
      marketItems,
    });
    for(let i = 0; i < marketItems.length; i++) {
      let marketItem = marketItems[i];
      marketItem["displayedSellerAddress"] = await encryptUtils.getENS(marketItem["sellerAddress"]);
      marketItems[i] = marketItem;
    }
    this.setState({
      marketItems,
      isLoading: false,
    });

    let data = await axios.get("https://api.coinbase.com/v2/exchange-rates", { params: { currency: "ETH" } });
    if(data != null) {
      this.setState({
        USDPrice: data["data"]["data"]["rates"]["USD"]
      })
    }

    const ppvContract = new web3.eth.Contract(contract.abi, usedContractAddress);
    const bondingCurveContract = new web3.eth.Contract(contract2.abi, usedContractAddressBondingCurve);

    let self = this;
    ppvContract.events.MarketItemDelisted().on("data", function(event) {
      let data = event.returnValues;
      let isForUser = false;
      for(let i = 0; i < marketItems.length; i++) {
        if(parseInt(marketItems[i]["marketItemId"]) === parseInt(data["marketItemId"])) {
          if(
            self.props.account != null &&
            marketItems[i]["sellerAddress"].toLowerCase() === self.props.account.address.toLowerCase() &&
            marketItems[i]["protocol"] === "the402"
          ) {
            isForUser = true;
          }
          marketItems.splice(i, 1);
          break;
        }
      }
      if(isForUser) {
        self.setState({
          marketItems,
          transactionStatus: "Delist Complete",
        });
      } else {
        self.setState({
          marketItems,
        });
      }
    }).on("error", function(event) {
      self.setState({
        transactionStatus: "Failed",
      });
    });

    ppvContract.events.MarketItemSold().on("data", function(event) {
      let data = event.returnValues;
      let isForUser = false;
      for(let i = 0; i < marketItems.length; i++) {
        if(
          parseInt(marketItems[i]["marketItemId"]) === parseInt(data["marketItemId"]) &&
          marketItems[i]["protocol"] === "the402"
        ) {
          if(
            self.props.account != null &&
            data["buyer"].toLowerCase() === self.props.account.address.toLowerCase()
          ) {
            isForUser = true;
          }
          marketItems.splice(i, 1);
          break;
        }
      }
      if(isForUser) {
        self.setState({
          marketItems,
          transactionStatus: "Purcase Complete",
        });
      } else {
        self.setState({
          marketItems,
        });
      }
    }).on("error", function(event) {
      self.setState({
        transactionStatus: "Failed",
      });
    });
    loggingUtils.logEvent(
      this.props.account != null ? this.props.account.address : encryptUtils.getWalletUnconnectedUserId(),
      'marketplace_secondaries',
      'marketplace_secondaries_page_load',
      'info',
      "https://the402.xyz",
      {},
    );

    bondingCurveContract.events.MarketItemDelisted().on("data", function(event) {
      let data = event.returnValues;
      let isForUser = false;
      for(let i = 0; i < marketItems.length; i++) {
        if(parseInt(marketItems[i]["marketItemId"]) === parseInt(data["marketItemId"])) {
          if(
            self.props.account != null &&
            marketItems[i]["sellerAddress"].toLowerCase() === self.props.account.address.toLowerCase() &&
            marketItems[i]["protocol"] === "liquid"
          ) {
            isForUser = true;
          }
          marketItems.splice(i, 1);
          break;
        }
      }
      if(isForUser) {
        self.setState({
          marketItems,
          transactionStatus: "Delist Complete",
        });
      } else {
        self.setState({
          marketItems,
        });
      }
    }).on("error", function(event) {
      self.setState({
        transactionStatus: "Failed",
      });
    });

    bondingCurveContract.events.MarketItemSold().on("data", function(event) {
      let data = event.returnValues;
      let isForUser = false;
      for(let i = 0; i < marketItems.length; i++) {
        if(
          parseInt(marketItems[i]["marketItemId"]) === parseInt(data["marketItemId"]) &&
          marketItems[i]["protocol"] === "liquid"
        ) {
          if(
            self.props.account != null &&
            data["buyer"].toLowerCase() === self.props.account.address.toLowerCase()
          ) {
            isForUser = true;
          }
          marketItems.splice(i, 1);
          break;
        }
      }
      if(isForUser) {
        self.setState({
          marketItems,
          transactionStatus: "Purcase Complete",
        });
      } else {
        self.setState({
          marketItems,
        });
      }
    }).on("error", function(event) {
      self.setState({
        transactionStatus: "Failed",
      });
    });
    loggingUtils.logEvent(
      this.props.account != null ? this.props.account.address : encryptUtils.getWalletUnconnectedUserId(),
      'marketplace_secondaries',
      'marketplace_secondaries_page_load',
      'info',
      "https://the402.xyz",
      {},
    );
  }

  render() {
    let holderPercentageShare = "0";
    if(this.state.item != null) {
      let holderShares = this.state.item.royaltySharesInfo.holderShares;
      let creatorShares = this.state.item.royaltySharesInfo.creatorShares;
      let mintCount = this.state.item.mintCount;
      holderPercentageShare = ((holderShares * 100) / (holderShares*mintCount + creatorShares)).toFixed(2);
    }
    return(
      <div className="flex min-h-screen">
        <PlatformSidebar
          modalShown={this.state.modalShown}
          selectModal={this.selectModal}
        />
        <TransactionStatus transactionStatus={this.state.transactionStatus} />
        {
          this.state.modalShown === 'createAccount'
            ?
          <Onboarding selectModal={this.selectModal} />
            :
          this.state.modalShown === 'addFunds'
            ?
          <AddFunds selectModal={this.selectModal} />
            :
          this.state.modalShown === 'importFromPassword'
            ?
          <ImportFromPassword selectModal={this.selectModal} />
            :
          null
        }
        <div className="flex flex-col justify-start w-full">
          {
            this.state.item != null
              ?
            <div className="w-screen mt-16 h-144 flex flex-col flex-wrap items-center justify-center bg-zinc-100 dark:bg-custom-gray">
              <img id="blurred" class="backgroundBlurredImagePlatform" src={this.state.item.imagePinata} alt="Current song" />
              <img class="relative object-cover h-28 w-28 rounded-object-cover rounded-full cursor-pointermd cursor-pointer" src={this.state.item.imagePinata} onClick={this.redirectToItem} alt="NFT cover" />
              <div class="relative text-4xl mt-4 md:text-6xl text-black dark:text-white font-bold">
                {
                  this.state.item.name.replaceAll("_", " ")
                }
              </div>
              <div className="bg-custom-black relative flex items-center justify-center w-36 h-12 rounded-md mt-4">
              <div class="relative text-md md:text-md text-zinc-200 dark:text-zinc-200">
                {
                  this.state.item.creatorAddress.substring(0, 5) + "..." + this.state.item.creatorAddress.substring(this.state.item.creatorAddress.length - 5)
                }
              </div>
              </div>
              <ShowMoreText
                className = "text-base relative text-center flex dark:text-white text-black mt-2 flex-col w-8/12"
                lines={3}
                more=<span className="dark:text-white text-black">Show more</span>
                less=<span className="dark:text-white text-black">Show less</span>
                onClick={this.executeOnClick}
                expanded={false}
                truncatedEndingComponent={"..."}
              >
              {
                this.state.item.description
              }
            </ShowMoreText>
              <div className="flex w-8/12 mt-4 justify-center">
                {
                  this.state.item.protocol === "the402"
                    ?
                  <div className="flex flex-col justify-center items-center mx-4">
                    <div className="w-auto text-zinc-600 dark:text-zinc-100 font-medium text-base">
                      {
                        this.state.item.mintCount + "/" + this.state.item.mintLimit
                      }
                    </div>
                    <div className="w-auto text-center text-zinc-500 font-medium text-xs lg:text-sm">
                      Minted Editions
                    </div>
                  </div>
                    :
                  <div className="flex flex-col justify-center items-center mx-4">
                    <div className="w-auto text-zinc-600 dark:text-zinc-100 font-medium text-base">
                      {
                        this.state.item.currentSupply
                      }
                    </div>
                    <div className="w-auto text-center text-zinc-500 font-medium text-xs lg:text-sm">
                      Minted Editions
                    </div>
                  </div>
                }
                <div className="flex flex-col justify-center items-center mx-4">
                  <div className="w-auto text-center text-zinc-600 dark:text-zinc-100 font-medium text-sm lg:text-base">
                    {(this.state.item.mintPrice / this.state.ethToWeiConversion).toFixed(3) + " ETH"}
                  </div>
                  <div className="w-auto text-center text-zinc-500 font-medium text-xs lg:text-sm">
                    {
                      this.state.item.protocol === "the402" ? "Mint price" : "Current price"
                    }
                  </div>
                </div>
                {
                  this.state.item.protocol === "the402"
                    ?
                  <div className="flex flex-col justify-center items-center mx-4">
                    <div className="w-auto text-center text-zinc-600 dark:text-zinc-100 font-medium text-sm lg:text-base">
                      {
                        (this.state.item.impressionFee / this.state.ethToWeiConversion).toFixed(3) + " ETH"
                      }
                    </div>
                    <div className="w-auto text-center text-zinc-500 font-medium text-xs md:text-sm">
                      Impression Fee
                    </div>
                  </div>
                    :
                  null
                }
                <div className="flex flex-col justify-center items-center mx-4">
                <div className="w-auto text-center text-zinc-600 dark:text-zinc-100 font-medium text-sm lg:text-base">
                  {
                    this.state.item.royalty + "%"
                  }
                </div>
                <div className="w-auto text-center text-zinc-500 font-medium text-xs lg:text-sm">
                  Royalty
                </div>
                </div>
                {
                  this.state.item.protocol === "the402"
                    ?
                  <div className="flex flex-col justify-center items-center mx-4">
                    <div className="w-auto text-center text-zinc-600 dark:text-zinc-100 font-medium text-sm lg:text-base">
                      {
                        holderPercentageShare + "%"
                      }
                    </div>
                    <div className="w-auto text-center text-zinc-500 font-medium text-xs lg:text-sm">
                      Impression share per holder
                    </div>
                  </div>
                    :
                  null
                }
                {
                  this.state.item.protocol === "liquid"
                    ?
                  <div className="flex flex-col justify-center items-center mx-4">
                    <div className="w-auto text-center text-zinc-600 dark:text-zinc-100 font-medium text-sm lg:text-base">
                      {
                        this.state.item.isSigmoid
                          ?
                        "Sigmoid"
                          :
                        this.state.item.parameters.length === 3
                          ?
                        "Quadratic"
                          :
                        this.state.item.parameters.length === 2
                          ?
                        "Linear"
                          :
                        "Flat"
                      }
                    </div>
                    <div className="w-auto text-center text-zinc-500 font-medium text-xs lg:text-sm">
                      Curve type
                    </div>
                  </div>
                    :
                  null
                }
              </div>
            </div>
              :
            null
          }
          {
            this.state.marketItems.length === 0 && !this.state.isLoading
              ?
            <div className="w-screen h-80 flex justify-center items-center text-center text-5xl text-black dark:text-white">
              No Editions Listed
            </div>
              :
            null
          }
          <div className="mt-20 sm:mt-0 grid grid-cols-1 xl:grid-cols-4 xl:gap-2 lg:grid-cols-3 lg:gap-4">
            {
              this.state.marketItems.map(marketItem => {
                return (
                  <PurchasedNFT
                    key={marketItem.marketItemId}
                    image={marketItem.imagePinata}
                    name={marketItem.name.split("_").join(" ")}
                    address={marketItem.displayedSellerAddress}
                    addressImage={marketItem.sellerProfileImage}
                    handleItemClick={() => {
                      window.location.href = window.location.origin + "/media/" + marketItem.authUUID + "?protocol=" + marketItem.protocol;
                    }}
                    handleCTAClick={async () => {
                      this.props.account != null && this.props.account.address.toLowerCase() === marketItem.sellerAddress
                        ?
                      await this.delistItem(marketItem)
                        :
                      await this.purchaseItem(marketItem);
                    }}
                    ctaText={
                      this.props.account != null && this.props.account.address.toLowerCase() === marketItem.sellerAddress
                        ?
                      "Unlist"
                        :
                      "Buy"
                    }
                    editions={marketItem.amount}
                    price={marketItem.price}
                  />
                );
              })
            }
          </div>
        </div>
      </div>
    );
  }
}

export default MarketplaceSecondaries;
